import { Stack } from "@mui/material";
import { ListItem, Text } from "@src/appV2/redesign/system/ui-components";

interface AuctionShiftInfoProps {
  workplaceName: string;
  dateDisplay: string;
  timeDisplay: string;
}

export function AuctionShiftInfo(props: AuctionShiftInfoProps) {
  const { workplaceName, dateDisplay, timeDisplay } = props;

  return (
    <ListItem sx={{ flexDirection: "column", alignItems: "center" }}>
      <Stack direction="column" spacing={2} alignItems="center">
        <Text
          gutterBottom
          semibold
          variant="h5"
          sx={{ textAlign: "center" }}
          color={(theme) => theme.palette.text.secondary}
        >
          {workplaceName}
        </Text>

        <Text
          variant="h6"
          sx={{ textAlign: "center" }}
          color={(theme) => theme.palette.text.secondary}
        >
          {dateDisplay}, {timeDisplay}
        </Text>
      </Stack>
    </ListItem>
  );
}
